module.exports = __webpack_public_path__ + "img/box2-5.9cb8014f.png";